import React, { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import Layout from '../../Layout';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import { NavrhUzneseniaVlady } from '../../../module/SprievodnyDokument/CreateFromForm';
import {
  updateNavrhUzneseniaVladyClient,
} from '../../../client/external/evidencnaaplikacia/navrhUzneseniaVladyClient';
import useNavrhUzneseniaVladyFormData from './hook/useNavrhUzneseniaVladyFormData';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';
import SuccessMessages from '../../../module/SuccessMessages';
import { useClient } from '../../../context/ClientStatusContext';

export const NavrhUzneseniaVladyEditPage = (): ReactElement => {
  const location = useLocation();
  const {
    type,
    year,
    index,
    stadiumUuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, stadiumUuid: string }>();

  const {
    formDataResponse,
    formDataStatus,
  } = useNavrhUzneseniaVladyFormData(
    type,
    year,
    index,
    'NavrhUzneseniaVladySlovenskejRepubliky',
    stadiumUuid,
  );

  const {
    wrapClient: updateNavrhUzneseniaVlady,
  } = useClient(updateNavrhUzneseniaVladyClient);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Návrh uznesenia vlády Slovenskej republiky',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={formDataStatus.loading}>
        {formDataStatus.finished && (
        <SecuredPage
          hasOpravneniePracovneKroky={formDataResponse?.materialDetail?.hasOpravnenieSprievodneDokumenty}
          requestStatus={formDataStatus?.responseCode}
        >
          <>
            <SuccessMessages />
            {formDataResponse?.materialDetail && formDataResponse?.formData && (
            <>
              <PageHeadingWithBackButton
                headingCaption={`Legislatívny proces ${formDataResponse.materialDetail.cisloLegislativnehoMaterialu}`}
                heading="Návrh uznesenia vlády Slovenskej republiky"
                withBackLink
              />
              <NavrhUzneseniaVlady
                material={formDataResponse.materialDetail}
                initialData={formDataResponse.formData}
                onSubmit={updateNavrhUzneseniaVlady}
              />
            </>
            )}
          </>
        </SecuredPage>
        )}
      </Loader>
    </Layout>
  );
};

export default NavrhUzneseniaVladyEditPage;
